/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type CustomerAddressesQueryVariables = Types.Exact<{
  customerAccessToken: Types.Scalars['String'];
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type CustomerAddressesQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', defaultAddress?: { __typename?: 'MailingAddress', id: string, formatted: Array<string>, firstName?: string | null, lastName?: string | null, company?: string | null, address1?: string | null, address2?: string | null, country?: string | null, province?: string | null, city?: string | null, zip?: string | null, phone?: string | null, countryCodeV2?: Types.CountryCode | null } | null, addresses: { __typename?: 'MailingAddressConnection', edges: Array<{ __typename?: 'MailingAddressEdge', node: { __typename?: 'MailingAddress', id: string, formatted: Array<string>, firstName?: string | null, lastName?: string | null, company?: string | null, address1?: string | null, address2?: string | null, country?: string | null, province?: string | null, city?: string | null, zip?: string | null, phone?: string | null, countryCodeV2?: Types.CountryCode | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | null };

export declare const customerAddresses: import("graphql").DocumentNode;

export const CustomerAddressesDocument = /*#__PURE__*/ `
    query customerAddresses($customerAccessToken: String!, $before: String, $after: String, $first: Int, $last: Int) {
  customer(customerAccessToken: $customerAccessToken) {
    defaultAddress {
      id
      formatted(withName: true)
      firstName
      lastName
      company
      address1
      address2
      country
      province
      city
      zip
      phone
      countryCodeV2
    }
    addresses(
      first: $first
      last: $last
      before: $before
      after: $after
      reverse: true
    ) {
      edges {
        node {
          id
          formatted(withName: true)
          firstName
          lastName
          company
          address1
          address2
          country
          province
          city
          zip
          phone
          countryCodeV2
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;
export const useCustomerAddressesQuery = <
      TData = CustomerAddressesQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: CustomerAddressesQueryVariables,
      options?: UseQueryOptions<CustomerAddressesQuery, TError, TData>
    ) =>
    useQuery<CustomerAddressesQuery, TError, TData>(
      ['customerAddresses', variables],
      fetcher<CustomerAddressesQuery, CustomerAddressesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CustomerAddressesDocument, variables, options),
      options
    );

useCustomerAddressesQuery.getKey = (variables: CustomerAddressesQueryVariables) => ['customerAddresses', variables];
;

useCustomerAddressesQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: CustomerAddressesQueryVariables, options?: RequestInit['headers']) => fetcher<CustomerAddressesQuery, CustomerAddressesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CustomerAddressesDocument, variables, options);